import { defineStore } from 'pinia';

export const useDebugStore = defineStore('debug', {
    state: () => ({
        enabled: false,
    }),
    actions: {
        enable() {
            this.enabled = true;
        },
        disable() {
            this.enabled = false;
        },
        toggle() {
            this.enabled = !this.enabled;
        },
    },
});
